import AppConfig from '@/config';
import log from '@/services/logger';


export default {
	install(Vue) {
		
        Vue.config.errorHandler = (error, vm, info) => {
            if (!AppConfig.env.production) 
				console.error(error);
			else
				log.error(error, 'Vue');
		};

        window.onerror = (message, source, line, column, error) => {
            if (!AppConfig.env.production) 
                console.error(error);
			else
				log.error(error, 'Window');	
		};

	}
};
